//<<<<<<< HEAD
if (!customElements.get('wishlist-viewer')) {
  customElements.define(
    'wishlist-viewer',
    class WishlistViewer extends HTMLElement {
      constructor() {
        super();
        this.CHUNK_SIZE = 20;

        this.customerId = this.dataset.customerId;
        this.productGridContainer = this.querySelector('[data-product-grid]');
        this.variantIds = [];
      }
      get customer() {
        return this.customerId != null && this.customerId != '';
      }
      set loading(loadingState) {
        this._loading = loadingState;
        this.classList.toggle('loading', loadingState);
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.toggle('hidden', !loadingState);
        }
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      get loading() {
        return this._loading;
      }
      connectedCallback() {
        if (this.customer) {
          this.init();
        } else {
          window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent('/pages/wishlist')}`;
          return false;
        }
      }
      async init() {
        try {
          this.loading = true;
          let handles = await this.fetchHandlesforCustomer();
          //console.log(handles);
          let urlsToFetch = [];
          let productCardArray = [];
          for (let i = 0; i < handles.length; i += this.CHUNK_SIZE) {
            const handleChunk = handles.slice(i, i + this.CHUNK_SIZE);
            let handleUrlParams = handleChunk.join('_');
            let cacheBustingString = (Math.random() + 1).toString(36).substring(7);
            urlsToFetch.push(`/?handles=${handleUrlParams}&sections=wishlist-product-grid&type=${cacheBustingString}`);
          }
          Promise.all(urlsToFetch.map((url) => fetch(url).then((resp) => resp.json()))).then((texts) => {
            texts.forEach((responseText) => {
              //console.log(responseText);
              let tmpHTML = document.createElement('div');
              tmpHTML.innerHTML = responseText['wishlist-product-grid'];
              const productGrid = tmpHTML.querySelector('[data-wishlist-product-grid]');
              let childrenArray = Array.from(productGrid.children);
              productCardArray.push(...childrenArray);
            });
            productCardArray.forEach((child) => {
              let childClone = child.cloneNode(true);
              childClone.classList.add('grid__item');
              this.productGridContainer.append(childClone);
            });
            this.variantIds.forEach((variantId) => {
              const productCardSwatch = this.productGridContainer.querySelector(
                `product-card-swatch[data-variant-id="${variantId}"]`
              );
              if (productCardSwatch) {
                productCardSwatch.handleButtonClick();
              }
            });
            this.loading = false;
          });
        } catch (e) {
          console.error(e);
        }
      }

      async fetchHandlesforCustomer() {
        //console.log('fetching');
        let response = await fetch(
          'https://limelace-wishlist.etempashopifyapps-server-i.co.uk/endpoints/retrieve_wishlist.php',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              customer_id: this.customerId,
            }),
          }
        );
        let data = await response.json();
        if (data.failed) {
          console.error(data.error_message);
          throw new Error('Something went wrong fetching the wishlist');
        }
        if (data.wishlist_empty) {
          document.getElementById('wishlist-empty-message').style.display = 'block';
          this.loading = false;
          return false;
        } else {
          const handles = [];
          data.wishlist_items.map((item) => {
            handles.push(item.Product_Handle);
            this.variantIds.push(Number(item.Variant_ID));
          });
          //console.log(this.variantIds);
          return handles;
        }
      }
    }
  );
}
//=======
if (!customElements.get('wishlist-viewer')) {
  customElements.define(
    'wishlist-viewer',
    class WishlistViewer extends HTMLElement {
      constructor() {
        super();
        this.CHUNK_SIZE = 20;

        this.customerId = this.dataset.customerId;
        this.productGridContainer = this.querySelector('[data-product-grid]');
        this.variantIds = [];
      }
      get customer() {
        return this.customerId != null && this.customerId != '';
      }
      set loading(loadingState) {
        this._loading = loadingState;
        this.classList.toggle('loading', loadingState);
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.toggle('hidden', !loadingState);
        }
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      get loading() {
        return this._loading;
      }
      connectedCallback() {
        if (this.customer) {
          this.init();
        } else {
          window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent('/pages/wishlist')}`;
          return false;
        }
      }
      async init() {
        try {
          this.loading = true;
          let handles = await this.fetchHandlesforCustomer();
          //console.log(handles);
          let urlsToFetch = [];
          let productCardArray = [];
          for (let i = 0; i < handles.length; i += this.CHUNK_SIZE) {
            const handleChunk = handles.slice(i, i + this.CHUNK_SIZE);
            let handleUrlParams = handleChunk.join('_');
            let cacheBustingString = (Math.random() + 1).toString(36).substring(7);
            urlsToFetch.push(`/?handles=${handleUrlParams}&sections=wishlist-product-grid&type=${cacheBustingString}`);
          }
          Promise.all(urlsToFetch.map((url) => fetch(url).then((resp) => resp.json()))).then((texts) => {
            texts.forEach((responseText) => {
              //console.log(responseText);
              let tmpHTML = document.createElement('div');
              tmpHTML.innerHTML = responseText['wishlist-product-grid'];
              const productGrid = tmpHTML.querySelector('[data-wishlist-product-grid]');
              let childrenArray = Array.from(productGrid.children);
              productCardArray.push(...childrenArray);
            });
            productCardArray.forEach((child) => {
              let childClone = child.cloneNode(true);
              childClone.classList.add('grid__item');
              this.productGridContainer.append(childClone);
            });
            this.variantIds.forEach((variantId) => {
              const productCardSwatch = this.productGridContainer.querySelector(
                `product-card-swatch[data-variant-id="${variantId}"]`
              );
              if (productCardSwatch) {
                productCardSwatch.handleButtonClick();
              }
            });
            this.loading = false;
          });
        } catch (e) {
          console.error(e);
        }
      }

      async fetchHandlesforCustomer() {
        //console.log('fetching');
        let response = await fetch(
          'https://limelace-wishlist.etempashopifyapps-server-i.co.uk/endpoints/retrieve_wishlist.php',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              customer_id: this.customerId,
            }),
          }
        );
        let data = await response.json();
        if (data.failed) {
          console.error(data.error_message);
          throw new Error('Something went wrong fetching the wishlist');
        }
        if (data.wishlist_empty) {
          document.getElementById('wishlist-empty-message').style.display = 'block';
          this.loading = false;
          return false;
        } else {
          const handles = [];
          data.wishlist_items.map((item) => {
            handles.push(item.Product_Handle);
            this.variantIds.push(Number(item.Variant_ID));
          });
          //console.log(this.variantIds);
          return handles;
        }
      }
    }
  );
}
//>>>>>>> f13c8f5380ae7a5ff45b15c026efecb23ed4a660
